import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useEvent } from 'react-use';

import { authActions } from 'app-components/flux/auth';

import { removeShareAcceptData } from 'data/app/helpers';
import { useGlobalSessionMismatch, useSharedSessionState } from './hooks';

const useOAuthHandler = () => {
  const dispatch = useDispatch();

  const [sharedSessionState] = useSharedSessionState();
  const [, setGlobalSessionMismatch] = useGlobalSessionMismatch();

  const eventHandler = useCallback(
    (event) => {
      if (event.data?.type === 'auth-failed' && event.origin === window.origin) {
        setGlobalSessionMismatch(true);
        return;
      }
      if (event.data?.type === 'auth' && event.origin === window.origin) {
        const { redirectUri } = event.data;
        if (redirectUri && !redirectUri.startsWith(window.location.origin)) {
          return;
        }
        const automationSessionState = sessionStorage.getItem('sessionState');
        if (
          assert(
            event.data?.sessionState === automationSessionState || event.data?.sessionState === sharedSessionState,
            'local sessionState does not match remote one',
          )
        ) {
          // once we have an auth-code, we can remove the share data so it is not used again
          removeShareAcceptData();
          dispatch(
            authActions.getOAuthToken(event.data.code, {
              props: { sessionState: event.data?.sessionState, redirectUri },
            }),
          );
        } else {
          setGlobalSessionMismatch(true);
        }
      }
    },
    [dispatch, sharedSessionState, setGlobalSessionMismatch],
  );
  useEvent('message', eventHandler);

  return null;
};

export default useOAuthHandler;
